var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.23 24.38A2.506 2.506 0 0 1 4 22.237v-4.88c0-.58.483-1.05 1.074-1.047.19 0 .375.05.54.143l11.255 6.421a2.088 2.088 0 0 1 1.064 1.81v5.056A1.267 1.267 0 0 1 16.65 31c-.236 0-.47-.064-.674-.185L5.23 24.38zm16.776-9.264a2.093 2.093 0 0 1 1.065 1.81v10.26a.83.83 0 0 1-.435.731l-2.463 1.356a.438.438 0 0 1-.1.04v-5.696c0-.738-.395-1.422-1.045-1.8L9.145 16.03V9.6c0-.582.483-1.05 1.076-1.048.19 0 .375.05.54.142l11.25 6.422h-.004zm4.928-7.578A2.088 2.088 0 0 1 28 9.35v14.987a.847.847 0 0 1-.45.738l-2.337 1.234V15.874c0-.736-.396-1.419-1.04-1.798L14.07 8.147V2.05c0-.187.052-.368.144-.529a1.087 1.087 0 0 1 1.465-.378l11.254 6.397v-.002z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComp);
export default __webpack_public_path__ + "static/media/COMP.bef8dc704d2a2be44cabed1270d548de.svg";
export { ForwardRef as ReactComponent };